/*
 * @Author: your name
 * @Date: 2022-03-04 09:49:00
 * @LastEditTime: 2022-03-04 15:42:58
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \3.0后台管理系统2022-01-18\hwason-manage-system\src\utils\download.js
 */
export default {
  download: function (url, obj) {
    let keyArr = [];
    if (obj) {
      keyArr = Object.keys(obj);
    }
    let form = document.createElement('form');
    form.id = 'formId';
    form.style.display = 'none';
    form.setAttribute('method', 'get');
    form.setAttribute('action', url);
    document.getElementsByTagName('body')[0].appendChild(form);
    for (let k of keyArr) {
      var input = document.createElement('input');
      input.setAttribute('name', k);
      if(k=='headers'){
        input.setAttribute('value', JSON.stringify(obj[k]));
      }else{
        input.setAttribute('value', obj[k]);
      }
      document.getElementById('formId').appendChild(input);
    }
    form.submit();
    document.getElementsByTagName('body')[0].removeChild(form);
  }
};
